import { DateTime } from 'luxon'

export default function formatToDay(text: string | undefined | null): string {
	return DateTime.fromISO(String(text)).toFormat('dd/MM/yyyy')
}
